import { css } from '@emotion/css'
import colors from '@styles/colors';

import { mobileOnly, tabletPortraitUp, tabletLandscapeUp, desktopUp, bigDesktopUp, max_900 } from '@styles/breakpoints';

import headerComingSoon from "@img/box-builder/Cerebelly_Web2_Banners_Coming_Soon_Desktop_Babbling.jpg";
import headerComingMobile from "@img/box-builder/Cerebelly_Web2_Banners_Coming_Soon_Mobile_Babbling.jpg";
import peppaIcon from "@img/box-builder/peppa-pig.svg";
import headerBackground from "@img/shop/header-background.avif";
import headerBackgroundMobile from "@img/shop/header-background-mobile.avif";

export default {
    pageContainer: css({
        padding: '0px !important',

        '.e-right-quiz': {
            button: {
                display: 'none',
                [tabletLandscapeUp]: {
                    marginLeft: 'auto',
                    display: 'block',
                },
            }
        },

        '.page-heading': {
            backgroundImage: `url(${headerBackground})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            padding: '100px 20px',
            width: '100%',
            textAlign: 'center',

            [mobileOnly]: {
                padding: '40px 60px',
                backgroundImage: `url(${headerBackgroundMobile})`,
            },

            h1: {
                textAlign: 'center',
                fontStyle: 'normal',
                fontWeight: 800,
                fontSize: 44,
                lineHeight: '115%',
                letterSpacing: '0.02em',
                color: colors.NAVY,
                marginBottom: 24,

                [mobileOnly]: {
                    fontSize: 30,
                    marginBottom: 20,
                }
            },

            p: {
                textAlign: 'center',
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: 20,
                lineHeight: '135%',
                letterSpacing: '0.02em',
                paddingBottom: 0,
                color: colors.BLUE,

                [mobileOnly]: {
                    fontSize: 17,
                    marginBottom: 0,
                }
            }
        },

        '@keyframes slide': {
            '0%': {
                transform: 'translate(0, 0)',
            },
            '100%': {
                transform: 'translate(-2900px, 0)',
            }
        },

        '.shop-carousel': {
            position: 'relative',
            width: '100%',
            height: 45,
            padding: '12px 0',
            backgroundColor: colors.BLUE_EXTRA_LIGHT,
            overflow: 'hidden',

            [mobileOnly]: {
                display: 'none'
            },

            'ul': {
                position: 'absolute',
                top: 7,
                padding: 0,
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'nowrap',
                flexDirection: 'row',
                listStyleType: 'none',
                width: 2900,
                animation: 'slide 60s linear infinite',
                backgroundColor: colors.BLUE_EXTRA_LIGHT,
                overflow: 'hidden',
                zIndex: 4,

                'li': {
                    color: colors.BLUE,
                    fontWeight: 'bold',
                    fontSize: 17,
                    letterSpacing: '0.01em',
                    display: 'inline-block',
                    margin: '0 24px',
                    whiteSpace: 'pre',
                    'span.shop-carousel-point': {
                        height: 7,
                        width: 7,
                        display: 'block',
                        borderRadius: 50,
                        backgroundColor: colors.BLUE,
                    }
                },

                '&.copy': {
                    //animationDelay: '30s',
                    zIndex: 3,
                    left: 1450,
                },
            }
        },
        '.personalized-box': {
            '.e-header-modal': {
                display: 'block',
                position: 'fixed',
                bottom: 34,
                right: 24,
                width: 90,
                height: 90,
                borderRadius: 10,
                backgroundColor: colors.WHITE,
                border: `1px solid ${colors.BLUE_EXTRA_LIGHT}`,
                boxShadow: '0px -2px 8px rgba(21, 32, 107, 0.05);',
                [tabletLandscapeUp]: {
                    display: 'none',
                },
                '.e-header-modal-count': {
                    minWidth: 22,
                    height: 22,
                    position: 'absolute',
                    top: -11,
                    right: -11,
                    backgroundColor: colors.BLUE,
                    color: colors.WHITE,
                    textAlign: 'center',
                    fontWeight: 600,
                    fontSize: 13,
                    lineHeight: '115%',
                    borderRadius: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingBottom: 2,
                },
                '.e-header-modal-image': {
                    padding: 14,
                    img: {
                        maxWidth: 62,
                        height: 62,
                        display: 'block',
                        margin: '0 auto',
                    },
                }
            }
        },
    }),

    container: css({
        flexWrap: 'wrap',

        [tabletPortraitUp]: {
            margin: '0px',
            padding: 0,
        },

        [tabletLandscapeUp]: {
            flexWrap: 'initial',

            '&:before': {
                flex: '0 0 0px',
            },
        },

        '@media (min-width: 969px)': {
            '&:before': {
                flex: '0 0 200px',
            }
        },

        '@media (min-width: 1200px)': {
            '&:before': {
                flex: '0 0 100px',
            }
        },

        '@media (min-width: 1265px)': {
            '&:before': {
                flex: '0 0 280px',
            }
        },

        '@media (min-width: 1440px)': {
            '&:before': {
                flex: '0 0 100px',
            }
        },

        'h1.desktop': {
            display: 'none',
            [tabletLandscapeUp]: {
                display: 'block',
            }
        },

        'h1.mobile': {
            display: 'block',
            maxWidth: '100%',
            padding: '0 25px',
            margin: '0 auto',
            marginBottom: 15,
            marginTop: 30,
            fontSize: 24,
            [tabletPortraitUp]: {
                maxWidth: 564,
                padding: '0 15px',
            },
            [tabletLandscapeUp]: {
                display: 'none',
            }
        },
        '.boxmenuContainer': {
            backgroundColor: colors.WHITE,
            position: 'sticky',
            order: 1,
            width: '100%',
            zIndex: 4,
            top: 46,
            height: '100%',
            left: 0,

            [tabletLandscapeUp]: {
                display: 'none',
                width: 'initial',
            },

            '@media (min-width: 984px)': {
                display: 'block',
                position: 'absolute',
                top: 'initial',
                width: 230,
            },
            '.subscribed': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'flex-start',
                position: 'static',
                padding: '15px 30px',
                transition: 'top 0.3s',

                label: {
                    fontWeight: 600,
                    fontSize: 16,
                    textAlign: 'center',
                    color: colors.GREEN_BRIGHT,

                    '.container-checkbox': {
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'nowrap',
                        alignItems: 'center',
                    },
                    '.styled-switch': {
                        width: '35px !important',
                        height: '19px !important',
                        marginRight: 3,
                        marginTop: 5,

                        '.switch-circle': {
                            width: '15px !important',
                            height: '15px !important',
                            left: '15px',
                        }
                    },

                    '.label': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        alignContent: 'flex-start',
                        textAlign: 'left',
                        marginLeft: 6
                    },

                    '.anytime': {
                        marginTop: 4,
                        fontWeight: 700,
                        fontSize: 11,
                        opacity: 0.7,
                        lineHeight: 1.2,
                    }
                },

                '&.inactive': {
                    label: {
                        color: colors.BLUE,
                    },
                },

                '&.desktop': {
                    display: 'none'
                },
                '&.mobile': {
                    display: 'block'
                },
                [tabletLandscapeUp]: {
                    padding: '0px',

                    '.container-checkbox': {
                        alignItems: 'flex-start',
                    },
                    '&.desktop': {
                        display: 'block'
                    },
                    '&.mobile': {
                        display: 'none'
                    },
                    '.anytime': {
                        marginTop: 8,
                    }
                },
            },
            '.sidebar': {
                marginBottom: 0,
                paddingTop: 25,
                paddingBottom: 15,
                backgroundColor: '#EBEEF6',

                [tabletLandscapeUp]: {
                    borderBottom: 0,
                    position: 'sticky',
                    top: 130,
                    paddingTop: 0,
                    paddingBottom: 0,
                    backgroundColor: colors.WHITE,
                },

                [mobileOnly]: {
                    overflowY: 'hidden',
                    overflowX: 'auto',

                    /*
                    '-ms-overflow-style': 'none',
                    scrollbarWidth: 'none',

                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    */
                },

                '.menu': {
                    marginLeft: 0,
                    display: 'flex',
                    padding: '0 25px',
                    flexDirection: 'row',
                    paddingBottom: 2,
                    marginBottom: -3,
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    [tabletPortraitUp]: {
                        maxWidth: 630,
                        margin: '0 auto',
                        justifyContent: 'flex-start',
                        padding: '0 15px',
                        left: '0 !important'
                    },
                    [tabletLandscapeUp]: {
                        maxWidth: 'auto',
                        marginLeft: 15,
                        paddingLeft: 15,
                        marginTop: 60,
                        display: 'inherit',
                        borderBottom: 'none',
                        justifyContent: 'inherit',
                    },
                    [desktopUp]: {
                        marginLeft: 0,
                    },
                    [bigDesktopUp]: {
                        width: 340,
                        paddingLeft: 120,
                        marginLeft: 0,
                    },

                    [mobileOnly]: {
                        position: 'relative',
                        overflow: 'visible',
                        transition: 'left 1s',

                        '.menu-the-dough-project': {
                            paddingRight: 30,
                        },
                    },
                    '.menu-item': {
                        display: 'block',
                        textDecoration: 'none',
                        marginRight: 20,
                        fontStyle: 'normal',
                        fontWeight: 600,
                        fontSize: '15px',
                        lineHeight: '145%',
                        letterSpacing: '0.01em',
                        color: colors.BLUE,
                        cursor: 'pointer',
                        whiteSpace: 'pre',
                        [tabletLandscapeUp]: {
                            marginBottom: 16,
                            marginRight: 0,
                            fontSize: '16px',
                        },
                        span: {
                            paddingBottom: 11,
                            display: 'block',
                            color: colors.BLUE,
                            opacity: 0.8,

                            [tabletLandscapeUp]: {
                                paddingBottom: 0,
                                width: '100%',
                                opacity: 0.8,
                            },

                            '&.active': {
                                color: colors.NAVY,
                                opacity: 1,
                                fontWeight: 800,
                                [tabletLandscapeUp]: {
                                    opacity: 1,
                                }
                            },
                        },

                        '&.active': {
                            [tabletLandscapeUp]: {
                                borderBottom: 'none',
                            }
                        },

                        '&.standalone-item': {
                            marginLeft: -150,
                            padding: '15px 10px 15px 150px',
                            backgroundColor: colors.BLUE_EXTRA_LIGHT,
                            opacity: 1,
                            [mobileOnly]: {
                                display: 'none',
                            },
                            [tabletPortraitUp]: {
                                display: 'none',
                            },
                            [tabletLandscapeUp]: {
                                display: 'block',
                            },
                            'img': {
                                marginLeft: 10,
                            },

                            '&.take-the-quiz': {
                                backgroundColor: colors.BEIGE_OVERVIEW,
                                marginTop: 40,
                            },

                            '&.gift-cards': {
                                backgroundColor: colors.TEAL_EXTRA_LIGHT,
                            },

                            '&.build-a-bundle': {
                                backgroundColor: colors.BLUE_EXTRA_LIGHT,
                            },

                            '&:hover': {
                                paddingLeft: 160,
                                transition: 'padding 0.1s ease-out',
                            },
                        }
                    },
                },
            },
        },

        '.boxmenuScroll': {
            top: '-20px',
        },

        '.mainContainer': {
            order: 2,

            '.pageContainer': {
                '@media (min-width: 984px) and (max-width: 1350px)': {
                    marginLeft: 200,
                },
            },
        },


        '.pageContainer > .container': {
            // marginTop: 67,
            [mobileOnly]: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            [tabletLandscapeUp]: {
                marginLeft: 'auto',
            },

            [desktopUp]: {
                marginLeft: 'auto',
            },
            'div[class^="element-"]': {
                marginLeft: 24,
                marginRight: 24,
                [desktopUp]: {
                    marginLeft: 30,
                    marginRight: 30,
                }
            },
            'div.element-picker': {
                [desktopUp]: {
                    marginLeft: 30,
                    marginRight: 30,
                }
            },
            '.element-personalized': {
                [mobileOnly]: {
                    marginTop: 0,
                },
                [tabletLandscapeUp]: {
                    marginTop: 60,
                }
            },
            'div.element-filter': {
                backgroundColor: colors.WHITE,
                padding: '0 0 15px 0',
                zIndex: 3,
                [mobileOnly]: {
                    position: 'sticky',
                    top: 70,
                },
                [tabletPortraitUp]: {
                    position: 'sticky',
                    padding: '15px 0 15px 0',
                    top: 50,
                },
                [tabletLandscapeUp]: {
                    top: 59,
                },
            },
            '.element-picker': {
                '.category.picker': {
                    '> div': {
                        [mobileOnly]: {
                            flexWrap: 'wrap',
                        },
                        '.method-quiz': {
                            [mobileOnly]: {
                                marginBottom: 20,
                            }
                        },
                        '.method-box-builder, .method-quiz': {
                            flexDirection: 'column',
                        },
                        '.method-title, .method-description': {
                            textAlign: 'center',
                        },
                        '.method-image': {
                            maxWidth: 'inherit',
                            '.desktop': {
                                [mobileOnly]: {
                                    display: 'block',
                                },
                            },
                            '.mobile': {
                                display: 'none',
                            },
                        }
                    }
                }
            },
            '.element-bundles': {
                '.products.highlight': {
                    '.developmental': {
                        [mobileOnly]: {
                            flexDirection: 'column',
                        },
                        [tabletPortraitUp]: {
                            flexDirection: 'column',
                        },
                        [tabletLandscapeUp]: {
                            flexDirection: 'row',
                        }
                    },
                    '.details-wrapper': {
                        [tabletLandscapeUp]: {
                            flexDirection: 'row',
                        }
                    }
                }
            },
            '.category': {
                '.show-all-action': {
                    textAlign: 'center',
                    textDecoration: 'underline',
                    color: colors.BLUE,
                    fontWeight: 'bold',
                    fontSize: 16,
                    width: '100%',
                    marginTop: 30,
                    marginBottom: 60,

                    [mobileOnly]: {
                        marginTop: 20,
                        marginBottom: 40,
                    },
                },
                '.category-title': {
                    [tabletLandscapeUp]: {
                        marginBottom: 21,
                    },
                    h2: {
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                        fontSize: 24,
                        lineHeight: '135%',
                        letterSpacing: '0.02em',
                        color: colors.NAVY,
                        marginBottom: 9,
                        [mobileOnly]: {
                            marginBottom: 15,
                        },

                        span: {
                            marginLeft: 15,
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: 15,
                            lineHeight: '135%',
                            letterSpacing: '0.02em',
                            color: colors.BLUE,
                        },
                    },
                    div: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignContent: 'flex-start',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',

                        [mobileOnly]: {
                            flexDirection: 'column',
                        },

                        p: {
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            fontSize: 16,
                            lineHeight: '145%',
                            letterSpacing: '0.01em',
                            margin: '0 !important'
                        },
                        img: {
                            marginLeft: 5,
                            [mobileOnly]: {
                                display: 'none',
                            }
                        }
                    },
                    '.veggie-option': {
                        span: {
                            fontSize: 16,
                            marginLeft: 14,
                            width: 100,
                        },
                        [mobileOnly]: {
                            marginTop: 24,
                            marginBottom: 24,
                        },
                    }
                },
                '.filter-row': {
                    [mobileOnly]: {
                        overflow: 'hidden',
                        marginLeft: -24,
                        marginRight: -24,
                        width: '100vw',
                    }
                },
                '.filter': {
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    alignContent: 'flex-start',
                    marginBottom: 36,
                    [mobileOnly]: {
                        marginBottom: 0,
                        flexWrap: 'nowrap',
                        padding: '0 24px',
                        overflow: 'auto',
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                        userSelect: 'none',
                        touchAction: 'manipulation !important',
                        '&::-webkit-scrollbar': {
                            width: 0,  /* Remove scrollbar space */
                            height: 0,
                            background: 'transparent',  /* Optional: just make scrollbar invisible */
                        },
                    },

                    span: {
                        background: colors.BLUE_EXTRA_LIGHT,
                        color: colors.NAVY,
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                        fontSize: 13,
                        lineHeight: '135%',
                        padding: '6px 16px',
                        borderRadius: 20,
                        marginRight: 10,
                        marginBottom: 10,
                        cursor: 'pointer',
                        whiteSpace: 'pre',
                        outline: 'none',
                        border: 'none',
                        '&.active': {
                            background: colors.BLUE,
                            color: colors.WHITE,
                        }
                    }
                },
                '.developmental': {
                    width: '100%',
                    display: 'flex',
                    backgroundColor: colors.BLUE_EXTRA_LIGHT,
                    marginBottom: 21,
                    flexDirection: 'column',

                    [mobileOnly]: {
                        padding: '24px 24px 36px 24px',
                    },
                    [tabletPortraitUp]: {
                        padding: '24px 24px 36px 24px',
                    },
                    [tabletLandscapeUp]: {
                        flexDirection: 'row',
                        padding: '35px 60px',
                        marginBottom: 26,
                        borderRadius: 10,
                    },

                    '.brain': {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        flex: '1 1 0',
                        [mobileOnly]: {
                            marginBottom: 26,
                        },
                        [tabletPortraitUp]: {
                            marginBottom: 30,
                        },
                        [tabletLandscapeUp]: {
                            marginBottom: 0,
                        },

                        span: {
                            flex: '1 1 0',
                            height: 'auto',
                            backgroundColor: '#ffffff',
                            borderRadius: '50%',
                            zIndex: 1,

                            [mobileOnly]: {
                                width: 131,
                            },
                            [tabletPortraitUp]: {
                                width: 131,
                            },
                            [tabletLandscapeUp]: {
                                width: 180,
                                marginRight: 40,
                            },

                            img: {
                                width: '100%',
                                height: 'auto',
                                padding: 20,
                            }
                        },

                        h3: {
                            flex: '1 1 0',
                            color: colors.NAVY,
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            letterSpacing: '0.2em',
                            textTransform: 'uppercase',
                            marginTop: 30,

                            [mobileOnly]: {
                                fontSize: 12,
                            },
                            [tabletPortraitUp]: {
                                fontSize: 13,
                            },
                            [tabletLandscapeUp]: {
                                fontSize: 13,
                            },

                            hr: {
                                borderBottom: `0.5px solid ${colors.BLUE}`,
                                marginTop: 20,
                                marginRight: '-10px',
                            }
                        },
                    },

                    '.details': {
                        flex: '1 1 0',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',

                        [mobileOnly]: {

                        },
                        [tabletPortraitUp]: {

                        },
                        [tabletLandscapeUp]: {
                            paddingLeft: 40,
                            borderLeft: `solid 2px ${colors.BLUE_LIGHT}`,
                        },

                        h3: {
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: 20,
                            letterSpacing: '0.02em',
                            marginBottom: 14,
                            color: colors.NAVY,
                            [mobileOnly]: {
                                fontSize: 16,
                            }
                        },
                        '.text': {
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: 14,
                            lineHeight: '145%',
                            letterSpacing: '0.01em',
                            marginBottom: 10,
                            color: colors.BLUE,
                            scrollbarColor: `${colors.BLUE_LIGHTER} ${colors.BLUE_EXTRA_LIGHT}`,
                            scrollbarWidth: 'thin',

                            [mobileOnly]: {
                                fontSize: 12,
                            },

                            '&::-webkit-scrollbar': {
                                width: 20,
                                height: 100,
                            },

                            '&::-webkit-scrollbar-thumb': {
                                background: colors.BLUE_LIGHTER,
                                borderRight: `15px solid ${colors.BLUE_EXTRA_LIGHT}`,
                                borderTop: `10px solid ${colors.BLUE_EXTRA_LIGHT}`,
                                borderBottom: `10px solid ${colors.BLUE_EXTRA_LIGHT}`,
                                backgroundClip: 'padding-box',
                            },

                            '&::-webkit-scrollbar-button': {
                                width: 0,
                                height: 0,
                                display: 'none',
                            },

                            '&::-webkit-scrollbar-corner': {
                                backgroundColor: 'transparent',
                            },
                        }
                    }

                },

                '.header': {
                    marginBottom: 30,

                    '.info': {
                        marginTop: 30,
                        borderRadius: 5,

                        '& > .row': {
                            height: '100%',
                        },
                    },
                },
                '.highlight': {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    marginBottom: 15,

                    '.details-wrapper': {
                        display: 'flex',

                        [mobileOnly]: {
                            flexDirection: 'column',
                        },
                        [tabletPortraitUp]: {
                            flexDirection: 'column',
                        },
                        [tabletLandscapeUp]: {
                            flexDirection: 'row',
                        },

                        '.image': {
                            flex: '1 1 0',
                            background: `${colors.BLUE_EXTRA_LIGHT} !important`,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignContent: 'center',

                            img: {
                                width: 'auto !important',
                            }
                        },

                        '.list': {
                            flex: '1 1 0',
                            display: 'flex',
                            justifyContent: 'center',
                            alignContent: 'center',
                            alignItems: 'stretch',

                            [mobileOnly]: {
                                flexDirection: 'column',
                            },
                            [tabletPortraitUp]: {
                                flexDirection: 'column',
                            },
                            [tabletLandscapeUp]: {
                                flexDirection: 'row',
                            },

                            '.items': {
                                flex: '1 1 0',
                                backgroundColor: colors.BLUE,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignContent: 'center',
                                alignItems: 'flex-start',
                                textAlign: 'left',

                                [mobileOnly]: {
                                    width: '100%',
                                    padding: '24px 32px 24px 24px',
                                },
                                [tabletPortraitUp]: {
                                    width: '100%',
                                    padding: '24px 32px 24px 24px',
                                },
                                [tabletLandscapeUp]: {
                                    minHeight: 225,
                                    width: 235,
                                    overflow: 'hidden',
                                    padding: '15px 20px',
                                },
                                span: {
                                    color: colors.WHITE,
                                    marginBottom: 8,
                                    fontStyle: 'normal',
                                    fontSize: 14,
                                    lineHeight: '145%',
                                }
                            },
                            '.nutrients': {
                                flex: '1 1 0',
                                backgroundColor: colors.BLUE_EXTRA_LIGHT,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignContent: 'center',
                                alignItems: 'flex-start',
                                textAlign: 'left',
                                [mobileOnly]: {
                                    width: '100%',
                                    padding: '24px 32px 24px 24px',
                                },
                                [tabletPortraitUp]: {
                                    width: '100%',
                                    padding: '24px 32px 24px 24px',
                                },
                                [tabletLandscapeUp]: {
                                    padding: '15px 20px',
                                    minHeight: 225,
                                    width: 235,
                                    overflow: 'hidden',
                                    borderTopRightRadius: 10,
                                    borderBottomRightRadius: 10,
                                },

                                span: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-start',
                                    alignContent: 'flex-start',
                                    alignItems: 'flex-start',
                                    color: colors.NAVY,
                                    marginBottom: 8,
                                    fontStyle: 'normal',
                                    fontSize: 14,
                                    lineHeight: '145%',
                                    '&:last-child': {
                                        marginBottom: 0,
                                    },

                                    img: {
                                        marginLeft: 5,
                                        maxWidth: 25,
                                    }
                                }
                            }
                        }
                    },
                    '.action-wrapper': {
                        display: 'flex',
                        flexDirection: 'row',
                        alignContent: 'center',
                        alignItems: 'flex-start',
                        [mobileOnly]: {
                            justifyContent: 'center',
                        },
                        [tabletPortraitUp]: {
                            justifyContent: 'center',
                        },
                        [tabletLandscapeUp]: {
                            justifyContent: 'space-between',
                        },

                        '.actions': {
                            display: 'flex',
                            flexDirection: 'row',
                            alignContent: 'center',
                            alignItems: 'flex-end',

                            '.show-all': {
                                fontStyle: 'normal',
                                fontWeight: 'bold',
                                fontSize: 16,
                                lineHeight: '100%',
                                cursor: 'pointer',
                                color: colors.BLUE,
                                width: '100%',
                                textAlign: 'center',
                                textDecoration: 'underline',
                                margin: 'auto',
                                display: 'block',
                                [mobileOnly]: {
                                },
                                [tabletPortraitUp]: {
                                },
                                [tabletLandscapeUp]: {
                                    marginRight: 60,
                                },
                            },

                            button: {
                                margin: '12px 0 6px',
                                width: 188,
                            }
                        },
                        '&.mobile': {
                            display: 'flex',
                            marginBottom: 32,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            order: 3,

                            [tabletLandscapeUp]: {
                                display: 'none',
                            },

                            '.actions': {
                                flexDirection: 'column-reverse',
                            }
                        },
                        '&.desktop': {
                            alignItems: 'center',
                            display: 'none',
                            '> div.actions': {
                                display: 'flex',
                                marginTop: 30,
                                [tabletLandscapeUp]: {
                                    marginTop: 0,
                                },

                                '.action.add': {
                                    display: 'none',
                                    [tabletLandscapeUp]: {
                                        display: 'flex',
                                    },
                                }
                            },
                            [tabletLandscapeUp]: {
                                display: 'flex',
                                '.action.add': {
                                    display: 'none',
                                }
                            }
                        }
                    }
                },
                '.products': {
                    '.product': {
                        position: 'relative',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',

                        '.warning-action': {
                            position: 'absolute',
                            top: '14px',
                            right: '10px'
                        },
                        '.highlight-action': {
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px'
                        },
                        '.product-link': {
                            cursor: 'pointer',
                            width: '100%',

                            '.image, picture, img': {
                                backgroundColor: '#ebeff8',
                                width: '100%',
                                position: 'relative',

                                '.tag': {
                                    color: colors.NAVY,
                                    backgroundColor: colors.WHITE,
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    borderRadius: 8,
                                    fontSize: 10,
                                    top: 12,
                                    right: 8,
                                    width: 100,
                                    textAlign: 'center',
                                    position: 'absolute',
                                },
                            },

                            '&.vertical': {
                                '@media screen and (min-width: 968px)': {
                                    '.image': {
                                        minHeight: 247,
                                    }
                                },

                                '@media screen and (min-width: 600px) and (max-width: 967px)': {
                                    '.image': {
                                        minHeight: 269,
                                    }
                                },

                                '@media screen and (min-width: 1200px)': {
                                    '.image': {
                                        minHeight: 269,
                                    }
                                },

                                '@media screen and (min-width: 1280px)': {
                                    '.image': {
                                        minHeight: 236,
                                    }
                                },
                            },

                            '&.horizontal': {
                                '@media screen and (min-width: 1200px)': {
                                    '.image': {
                                        minHeight: 227,
                                    }
                                },

                                '@media screen and (min-width:968px)': {
                                    '.image': {
                                        minHeight: 174,
                                    }
                                },

                                '@media screen and (min-width: 600px)': {
                                    '.image': {
                                        minHeight: 197,
                                    }
                                },
                            },
                        },
                        '.variety-pack-quantity': {
                            '.default': { margin: '0 auto 0 0 !important' }
                        },

                        '.image': {
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            justifyContent: 'center',
                            background: '#e9e9e9',
                            alignContent: 'center',
                            alignItems: 'center',
                            borderRadius: 5,
                            [mobileOnly]: {
                                marginBottom: 15,
                            },
                            [tabletPortraitUp]: {

                            },
                            [tabletLandscapeUp]: {
                                overflow: 'hidden',
                            },
                            '&.image-highlight': {
                                display: 'flex',
                                height: '100%',
                                img: {
                                    display: 'block',
                                    transition: 'all 0.3s ease 0s',
                                    width: '100% !important',
                                    imageRendering: '-webkit-optimize-contrast',
                                    '&:hover': {
                                        [tabletLandscapeUp]: {
                                            transform: 'scale(1.05)',
                                        },
                                    },
                                },
                            },

                            img: {
                                display: 'block',
                                transition: 'all 0.3s ease 0s',
                                width: '100%',
                                imageRendering: '-webkit-optimize-contrast',
                                // height: '100%',

                                '&:hover': {
                                    [mobileOnly]: {

                                    },
                                    [tabletPortraitUp]: {

                                    },
                                    [tabletLandscapeUp]: {
                                        transform: 'scale(1.05)',
                                    },
                                },
                            },
                        },

                        '.title': {
                            display: 'inline-block',
                            margin: '12px 0 6px',
                            textAlign: 'left',
                            fontWeight: 600,
                            fontSize: '16px',
                            lineHeight: '145%',
                            letterSpacing: '0.01em',
                        },
                        '.desktop': {
                            display: 'block',
                            [mobileOnly]: {
                                display: 'none',
                            }
                        },
                        '.mobile': {
                            display: 'none',
                            [mobileOnly]: {
                                display: 'block',
                            }
                        },
                        '.tooltip > .ing-tooltip > p': {
                            color: `${colors.GREEN_BRIGHT}`,
                        },
                        '.quantity': {
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            fontSize: 13,
                            lineHeight: '135%',
                            letterSpacing: '0.01em',
                            color: colors.BLUE,
                        },
                        '.info': {
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            fontSize: 13,
                            lineHeight: '135%',
                            letterSpacing: '0.01em',
                            color: colors.BLUE,
                            marginBottom: 15,
                            display: 'flex',
                            justifyContent: 'flex-start',
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            alignItems: 'center',

                            '.default': {
                                color: colors.BLUE,
                                marginRight: 6,
                            },
                            '.regular': {
                                color: colors.BLUE,
                                textDecorationLine: 'line-through',
                                marginRight: 6,
                            },
                            '.discount': {
                                color: colors.GREEN_BRIGHT,
                                marginRight: 6,
                            }
                        },

                        '.new-info': {
                            display: 'none',
                            top: 8,
                            right: 8,
                            padding: '5px 6px',
                            position: 'absolute',
                            color: colors.NAVY,
                            backgroundColor: colors.WHITE,
                            textTransform: 'capitalize',
                            fontWeight: 400,
                            fontSize: 10,
                            lineHeight: '10px',
                            textAlign: 'center',
                            letterSpacing: '0.1em',
                            borderRadius: '2px',
                            fontFamily: "'sofia-pro', sans-serif",
                            boxSizing: 'border-box',
                        },

                        '.out-of-stock-info': {
                            display: 'none',
                            width: 56,
                            height: 56,
                            borderRadius: 28,
                            paddingTop: 18,
                            top: 10,
                            right: 10,
                            position: 'absolute',
                            transform: 'rotate(15deg)',
                            color: colors.WHITE,
                            backgroundColor: colors.RED,
                            textTransform: 'uppercase',
                            fontWeight: 600,
                            fontSize: '10px',
                            lineHeight: '10px',
                            textAlign: 'center',
                            letterSpacing: '0.1em',
                            boxSizing: 'border-box', //mobile safari OS bug fixing
                        },

                        '.out-of-stock-button': {
                            textAlign: 'left',
                            'button': {
                                width: '100%',
                                maxWidth: 200,

                                '&:hover': {
                                    color: colors.WHITE,
                                },
                            }
                        },

                        '.out-of-stock-modal': {
                            textAlign: 'center',
                            display: 'flex',
                        },

                        '.recommended-info': {
                            display: 'none',
                            top: 10,
                            right: 10,
                            position: 'absolute',
                            color: colors.NAVY,
                            backgroundColor: colors.WHITE,
                            borderRadius: 2,
                            fontSize: 10,
                            lineHeight: '10px',
                            padding: '5px 6px',
                            letterSpacing: '0.01em',
                        },

                        '.age-bundle-nfo': {
                            top: 10,
                            right: 10,
                            position: 'absolute',
                            color: colors.NAVY,
                            backgroundColor: colors.WHITE,
                            borderRadius: 2,
                            fontSize: 13,
                            lineHeight: '10px',
                            padding: '5px 6px',
                            letterSpacing: '0.01em',
                        },

                        '.peppa-pig': {
                            display: 'none',
                            top: 8,
                            right: 8,
                            position: 'absolute',
                            backgroundImage: `url(${peppaIcon})`,
                            width: 54,
                            height: 31,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain'
                        },

                        '.actions': {
                            '.quantity': {
                                maxWidth: 145,
                                margin: 'auto',
                                userSelect: 'none',
                            }
                        },

                        '.action': {
                            button: {
                                width: '100%',
                                maxWidth: 200,
                                padding: '10px 15px',
                            },
                        },

                        '.added': {
                            height: 40,
                            width: '100%',
                            maxWidth: 160,

                            input: {
                                height: 40,
                                fontWeight: 600,
                                fontSize: 14,
                                textAlign: 'center',
                                letterSpacing: '0.01em',
                                borderRadius: 2,
                                lineHeight: '19px',
                            },

                            button: {
                                width: 40,

                                span: {
                                    position: 'relative',
                                    top: '-5px',
                                },
                            },
                        },

                        '&.out-of-stock': {
                            '&:not(.with-amount)': {
                                '.action': {
                                    display: 'none',
                                },
                            },

                            '.out-of-stock-info': {
                                display: 'block',
                            },
                        },

                        '&.new': {
                            '.new-info': {
                                display: 'block',
                            },
                        },

                        '&.recommended': {
                            '.recommended-info': {
                                display: 'block',
                            }
                        },

                        '&.peppa': {
                            '.peppa-pig': {
                                display: 'none',
                            }
                        },
                        '.stars': {
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            width: '50%',
                            '&.mobile': {
                                position: 'absolute',
                                left: 5,
                                top: 10,
                                [mobileOnly]: {
                                    '.ing-tooltip': {
                                        left: 'auto',
                                        right: 0,
                                    }
                                },
                                [tabletPortraitUp]: {
                                    '.ing-tooltip': {
                                        left: 'auto',
                                        right: 0,
                                    }
                                },
                                [tabletLandscapeUp]: {
                                    '.ing-tooltip': {
                                        left: 'inherit',
                                        right: 'auto',
                                    }
                                },
                            },
                            '.star': {
                                marginLeft: 5,
                            }
                        }
                    },

                    '.age-bundle-product': {
                        display: 'block',

                        '.image': {
                            height: 'auto',
                            position: 'relative',

                            img: {
                                width: '100%',
                                height: 'auto',
                            }
                        },

                        '.highlight-action': {
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px'
                        },
                    },

                    '.highlight-product': {
                        '.image-highlight-wrapper': {
                            position: 'relative',
                            width: '100%',
                            display: 'block',
                            backgroundSize: '0 0',

                            [tabletLandscapeUp]: {
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                backgroundColor: '#eceff6',
                            },
                        },
                        '.image': {
                            height: 'auto',

                            img: {
                                maxWidth: 600,
                                width: '100%',
                                height: 'auto',
                                display: 'block',

                                [tabletLandscapeUp]: {
                                    display: 'none',
                                }

                            }
                        },

                        '.action': {
                            button: {
                                width: 200,
                            },
                        },

                        '.bundle-picker': {
                            marginLeft: 'auto',
                            marginTop: '0 !important',
                        }
                    },

                    '.bundle-picker': {
                        color: colors.BLUE,
                        textDecoration: 'underline',
                        textTransform: 'none',
                        fontWeight: 'bold',
                        fontSize: 13,
                        marginTop: 13,
                        textAlight: 'left',

                        '&:hover': {
                            backgroundColor: colors.WHITE,
                            color: colors.NAVY
                        }
                    },
                },
            },
            '.personalized': {
                '.header.personalized': {
                    backgroundColor: colors.BEIGE_MILESTONE,
                    padding: '36px 24px 56px 24px',
                    margin: '6px -24px 27px -24px',
                    borderRadius: 10,

                    [mobileOnly]: {
                        padding: '25px 23px 8px 23px',
                        margin: '-40px -24px 45px -24px',
                        borderRadius: 0,
                    },
                    '.sub-title': {
                        display: 'flex',
                        flexWrap: 'nowrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        alignContent: 'center',
                        marginBottom: 20,

                        '.recommended-for': {
                            textAlign: 'left',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: 12,
                            letterSpacing: '0.2em',
                            textTransform: 'uppercase',
                            color: colors.BLUE,
                        },
                        '.see-why': {
                            display: 'inline-flex',
                            textAlign: 'right',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: 16,
                            letterSpacing: '0.01em',
                            color: colors.BLUE,
                            flex: 'none',
                            order: 0,
                            flexGrow: 0,
                            margin: '0px 5px',

                            img: {
                                marginLeft: 5,
                            }
                        },
                    },
                    '.products': {
                        '.title': {
                            margin: '15px 0 6px',
                            textAlign: 'center',
                        },
                    },
                    '.info': {
                        button: {
                            display: 'block',
                            marginLeft: 'auto',
                            width: '100%',
                            maxWidth: 313,
                            paddingTop: 17,
                            paddingBottom: 17,
                        },
                        '.pros-list': {
                            div: {
                                textAlight: 'left',
                                marginBottom: 10,
                                display: 'flex',
                                flexDirection: 'row',
                                alignContent: 'flex-start',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                color: colors.BLUE,

                                img: {
                                    marginBottom: 'auto',
                                    marginRight: 20,
                                    paddingTop: 3,
                                }
                            }
                        },
                        '.nutrients': {
                            marginTop: 32,
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            marginRight: '-8px',
                        }
                    }
                }
            },
            '.category.picker': {
                padding: 0,
            },
            '.the-dough-project': {
                '.toggle': {
                    background: 'none',
                    border: 'none',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    fontSize: 13,
                    lineHeight: '135%',
                    padding: 0,
                    marginRight: 7,
                    color: colors.BLUE,

                    '.arrow': {
                        width: 'auto !important',
                        marginLeft: 10,
                        background: 'white !important',
                    }
                },
                '.collapse': {
                    marginTop: 8,
                },
                '.product-link': {
                    '.image': {
                        maxHeight: '100%',
                        minHeight: '100% !important',
                        background: 'linear-gradient(135deg, rgb(216 218 210) 0%, rgb(228 231 228) 50%, rgb(228 229 227) 100%) !important',
                        padding: 0,

                        picture: {
                            background: 'linear-gradient(135deg, rgb(216 218 210) 0%, rgb(228 231 228) 50%, rgb(228 229 227) 100%) !important',
                        },

                        img: {
                            paddingTop: 0,
                            backgroundColor: '#e1e1dd !important',
                        }
                    },
                    '@media screen and (min-width: 900px)': {
                        '.image': {
                            maxHeight: 190,
                            minHeight: '180px !important',
                            padding: 30,

                            img: {
                                paddingTop: 30,
                            }
                        }
                    },
                    '@media screen and (min-width: 1280px)': {
                        '.image': {
                            maxHeight: 220,
                            minHeight: '197px !important',
                        }
                    },
                },
                '.added': {
                    marginLeft: '0px !important',
                    '.added-container': {
                        button: {
                            padding: '0px !important'
                        }
                }
                }
            }
        },
    }),


    upcomingBanner: css({
        '.header': {
            '.info': {
                backgroundColor: colors.COMING_SOON,

                '.info-text': {
                    padding: '40px 25px 30px 34px',

                    [tabletLandscapeUp]: {
                        padding: '50px 20px 50px 70px',
                    },
                },

                h4: {
                    fontWeight: 600,
                    fontSize: 12,
                    lineHeight: '133%',
                    letterSpacing: '0.2em',
                    color: colors.NAVY,
                    marginBottom: 20,
                    textTransform: 'uppercase',
                },

                h3: {
                    fontWeight: 700,
                    maxWidth: 401,
                    color: colors.NAVY,
                    fontSize: 22,
                    lineHeight: '135%',
                    marginBottom: 20,

                    [tabletLandscapeUp]: {
                        fontSize: 24,
                        marginBottom: 15,
                    }
                },

                '.upcoming-form': {
                    display: 'flex',
                    justifyContent: 'flex-start',
                    flexDirection: 'column',
                    position: 'relative',

                    [tabletLandscapeUp]: {
                        alignItems: 'center',
                        flexDirection: 'row',
                    },
                },

                '.error-message': {
                    position: 'absolute',
                    left: 0,
                    bottom: -20,
                    width: '100%',
                },

                '.confirmation-message': {
                    height: 40,
                    lineHeight: 1,
                    display: 'flex',
                    alignItems: 'center',
                },

                input: {
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 'auto',
                    height: 40,
                    marginTop: 0,
                    marginBottom: 15,

                    [tabletLandscapeUp]: {
                        maxWidth: 268,
                        marginRight: 10,
                        marginBottom: 0,
                    },
                },

                'button.button': {
                    height: 37,
                    maxWidth: '100%',
                    width: '100%',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: 13,
                    lineHeight: 1,
                    letterSpacing: '0.2em',
                    padding: '10px 10px 11px 10px',

                    [tabletLandscapeUp]: {
                        maxWidth: 123,
                    },
                },

                '.info-image': {
                    '.image': {
                        width: '100%',
                        backgroundImage: `url(${headerComingMobile})`,
                        backgroundPosition: 'bottom center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        [mobileOnly]: {
                            height: 150,
                        },
                        [tabletPortraitUp]: {
                            height: 150,
                        },
                        [tabletLandscapeUp]: {
                            height: '100%',
                            backgroundImage: `url(${headerComingSoon})`,
                            backgroundPosition: '0 0',
                            backgroundSize: 'cover',
                        },
                        [desktopUp]: {
                            backgroundImage: `url(${headerComingSoon})`,
                            backgroundPosition: '0 -10px',
                            backgroundSize: 'cover',
                        },
                    },
                },
            },
        },
    }),
};
